export default {
  'ModalHeader.Header.CloseButton.Button': ({ }, stateManager) => {
    stateManager.setTermsModal(false);
  }
}
